import React from 'react';
import {
  carAvatar,
  tierAvatar,
  VEHICLE_POSITION,
  VEHICLE_TYPE,
} from '../../../../common/constant/interactive.resume.constant';
import { classnames } from '../../../../common/general-utilities/general-utilities';
import { IDefaultResponsiveSupport } from '../../../../common/interfaces/common.interface';
import ResponsiveModeService from '../../../../common/services/responsive-mode.service';
import styles from './car.module.scss';

interface ICarComponent extends IDefaultResponsiveSupport {
  style?: React.CSSProperties;
  classes?: string[] | undefined;
  forwardRef?: React.RefObject<any>;
  isRotateBack: boolean;
  isVisible: boolean;
  isRunning?: boolean;
  type: VEHICLE_TYPE;
  position?: VEHICLE_POSITION;
}
export default class CarComponent extends React.Component<ICarComponent> {
  shouldComponentUpdate(prevProps: ICarComponent) {
    if (
      this.props.isRotateBack !== prevProps.isRotateBack ||
      this.props.isVisible !== prevProps.isVisible ||
      this.props.isRunning !== prevProps.isRunning ||
      this.props.responsiveMode !== prevProps.responsiveMode
    ) {
      return true;
    }
    return false;
  }

  render() {
    const {
      responsiveMode,
      style,
      classes,
      forwardRef,
      isRotateBack,
      isVisible,
      isRunning,
      type,
      position,
    } = this.props;

    const classesProps: string[] = classes ? classes : [];
    const tierStyle = {
      backgroundImage: tierAvatar,
    };
    return (
      <div
        ref={forwardRef}
        style={{
          backgroundImage: carAvatar,
          ...style,
        }}
        className={classnames(
          styles.carContainer,
          {
            [styles.rotateBack]: isRotateBack,
            [styles.hidden]: !isVisible,
            [styles.enableScale]: type === VEHICLE_TYPE.EMPTY,
            [styles.positionLeft]: position === VEHICLE_POSITION.LEFT,
            [styles.positionRight]: position === VEHICLE_POSITION.RIGHT,
          },
          ResponsiveModeService.responsiveModeClass(styles, responsiveMode),
          ...classesProps
        )}
      >
        <div
          style={tierStyle}
          className={classnames(styles.tiers, styles.leftTier, {
            [styles.paused]: !isRunning,
          })}
        ></div>
        <div
          style={tierStyle}
          className={classnames(styles.tiers, styles.rightTier, {
            [styles.paused]: !isRunning,
          })}
        ></div>
        { type === VEHICLE_TYPE.FULL ? <div className={classnames(styles.light)}></div> : null}
        
      </div>
    );
  }
}
